var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C10.866 14 14 10.866 14 7C14 3.13403 10.866 0 7 0C3.13403 0 0 3.13403 0 7C0 10.866 3.13403 14 7 14ZM10.6327 5.83923C10.8749 5.86292 10.9556 5.93347 10.9879 6.03833C11.0205 6.14319 10.9949 6.25 10.8121 6.41846L9.14526 7.95386C9.04626 8.04529 9.0188 8.13403 9.04761 8.2688L9.53564 10.5386C9.58887 10.7875 9.54993 10.8898 9.46484 10.9545C9.37976 11.0193 9.2749 11.0267 9.06567 10.8966L7.15784 9.70874C7.1012 9.67346 7.05066 9.65576 7.00012 9.65576C6.94958 9.65564 6.89893 9.67334 6.84229 9.70874L4.93433 10.8966C4.7251 11.0269 4.62036 11.0194 4.53528 10.9546C4.4502 10.8899 4.41101 10.7876 4.46436 10.5387L4.95239 8.26892C4.98132 8.13416 4.95386 8.04529 4.85486 7.9541L3.18799 6.41846C3.00513 6.25012 2.97949 6.14331 3.01196 6.03845C3.04443 5.93359 3.12524 5.86292 3.36731 5.83936L5.57666 5.62439C5.6615 5.61621 5.72156 5.59033 5.76746 5.53894C5.7926 5.51074 5.8136 5.47485 5.83203 5.43005L6.70972 3.29297C6.7644 3.15979 6.81665 3.08337 6.87097 3.04224C6.91223 3.01086 6.95471 3 7.00012 3C7.10535 3 7.19421 3.05859 7.29041 3.29272L8.16797 5.42981C8.19995 5.50757 8.23938 5.55823 8.29541 5.58875C8.33069 5.60803 8.37256 5.61926 8.42334 5.62427L10.6327 5.83923Z",
    fill: "#66BB6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.206de1c5a1a2cdf617e1a4eb45b7e73a.svg";
export { ForwardRef as ReactComponent };